import React from 'react'
import { ComponentExt } from 'util/reactExt'
import PDF from './pdf'
import * as styles from './index.scss'
import { Icon, Button, Modal } from 'antd'
import CollectPanel from '../CollectPanel'

enum TCourse {
  pdf = '1100103',
  img = '1100105',
  zip = '1100106',
}

type TInfo = {
  id: number
  article_id: number
  type: string
  content: string
  title: string
  publish_date: number
  labels: object[]
  view_count: number
  collect: {
    collect_count: number
    has_collect: 0 | 1
  }
  courseware_url: string
  homework_id: number
  article_desc: string
  img_url: string
  recommand_count: number
  password: number
  praise_count: number
  has_praise: number
  course_time: number
  random: string
  download_count: number
  courseware_show_status: number
  related: {
    id: number
    type: number
  }
  details_img_url: string
}

interface Props {
  info: TInfo
}

interface State {
  id: number
  info: TInfo
  collectModal: boolean
  visible: boolean
  previewImg: string
}

class CoursePreview extends ComponentExt<Props, State> {
  private timer // 计时器，课程计时用

  constructor(props) {
    super(props)
    this.state = {
      id: 0,
      info: {} as TInfo,
      collectModal: false,
      visible: false,
      previewImg: '',
    }
  }

  componentDidMount() {
    this.studying()
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  static getDerivedStateFromProps(props) {
    return {
      info: props.info,
      id: props.info ? props.info.id : 0,
    }
  }

  async studying() {
    const { id, random } = this.state.info
    await this.api.article.statistics(id, random)

    this.timer = setTimeout(() => {
      this.studying()
    }, 60000)
  }

  async likeAnswer(id) {
    try {
      await this.api.course.likeArticle(id)
      console.log('点赞成功')
    } catch (err) {
      console.error(err.message)
    }
  }

  async fetchCollectSave(cid, id) {
    const { type } = this.state.info
    try {
      const { msg } = await this.api.course.collect(cid, id, type)
      this.$message.success(msg || '收藏成功')
      this.setState({
        collectModal: false,
      })
    } catch (err) {
      this.$message.error('错误')
    }
  }

  async fetchCollectCancel(id) {
    const { type } = this.state.info
    try {
      const data = await this.api.course.cancelFavorite(id, type)
      this.$message.success(data || '取消成功')
    } catch (err) {
      this.$message.error('操作错误')
      console.error(err)
    }
  }

  async unlikeAnswer(id) {
    // 视频取消点赞
    try {
      await this.api.course.unLikeArticle(id)
      console.log('取消点赞成功')
    } catch (err) {
      console.error(err.message)
    }
  }

  handleCollect = () => {
    const info = this.state.info
    switch (this.state.info.collect.has_collect) {
      case 0:
        this.setState({
          collectModal: true,
        })
        break
      case 1:
        info.collect.collect_count = +info.collect.collect_count - 1
        info.collect.has_collect = 0
        this.setState({ info })
        this.fetchCollectCancel(this.state.id)
        break
    }
  }

  download = async () => {
    const { courseware_url, id } = this.state.info
    await this.api.course.downloadData(id)
    window.open(courseware_url)
  }

  onlike = () => {
    const info = this.state.info
    const id = this.state.id
    switch (info.has_praise) {
      case 0:
        info.has_praise = 1
        info.praise_count = Number(info.praise_count) + 1
        this.likeAnswer(id)
        break
      case 1:
        info.has_praise = 0
        info.praise_count = Number(info.praise_count) - 1
        this.unlikeAnswer(id)
        break
    }
    this.setState({ info })
  }

  handleConfirm = val => {
    const info = this.state.info
    info.collect.collect_count = +info.collect.collect_count + 1
    info.collect.has_collect = 1
    this.setState({ info })
    this.fetchCollectSave(val, this.state.id)
  }

  cancelModal = () => this.setState({ collectModal: false })

  handleCancel = () =>
    this.setState({
      visible: false,
      previewImg: '',
    })

  handleImg = () =>
    this.setState({
      previewImg: this.state.info.courseware_url,
      visible: true,
    })

  toDetail = (id, type) => {
    window.open(`#/course/${id}?type=${type}`)
  }

  render() {
    const { info } = this.props
    const { collectModal } = this.state
    const isCollect = Boolean(info.collect.has_collect)
    const isPraise = Boolean(info.has_praise)

    const docView = (_src, _type) =>
      _src ? (
        _type === '1100103' ? (
          <PDF src={_src} />
        ) : (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${_src}&wdStartOn=1&wdPrint=0&wdEmbedCode=0`}
            width="810px"
            height="600px"
            frameBorder="0"
          />
        )
      ) : null

    const imgView = (_src, _title?) => (
      <a onClick={() => this.handleImg()}>
        <img src={_src} alt={_title} />
      </a>
    )

    const defaultImg = url => (
      <div
        style={{
          backgroundImage: `url(${url})`,
          backgroundPosition: 'top center',
          backgroundSize: '100%',
          width: 940,
        }}
      />
    )

    const collectBtn = (
      <div onClick={() => this.handleCollect()} className={styles.button}>
        <Icon
          type={isCollect ? 'star' : 'star-o'}
          style={{ color: isCollect && '#FF3C00', fontSize: 20 }}
        />
        <span>
          {isCollect ? '已收藏' : `${info.collect.collect_count}人收藏`}
        </span>
      </div>
    )

    const likeBtn = (
      <div onClick={() => this.onlike()} className={styles.button}>
        <Icon
          type={isPraise ? 'like' : 'like-o'}
          style={{ color: isPraise && '#FF3C00', fontSize: 20 }}
        />
        <span>{`${info.praise_count || 0}人点赞`}</span>
      </div>
    )

    const modalRender = () => (
      <Modal
        title="收藏视频"
        visible={collectModal}
        onCancel={this.cancelModal}
        footer={null}
        style={{ top: '30%' }}
        bodyStyle={{ padding: 0 }}
      >
        <CollectPanel onConfirm={this.handleConfirm} />
      </Modal>
    )

    const previewPic = url => (
      <Modal
        visible={this.state.visible}
        destroyOnClose
        footer={null}
        width={1200}
        onCancel={this.handleCancel}
      >
        <img src={url} style={{ width: '100%' }} />
      </Modal>
    )

    return (
      <div>
        <div className={styles.coursepreviewInner}>
          <div className={styles.coursepreviewBody}>
            {!!info.courseware_show_status
              ? info.type === TCourse.img
                ? imgView(info.courseware_url, info.title)
                : info.type === TCourse.zip
                  ? defaultImg(info.details_img_url)
                  : docView(info.courseware_url, info.type)
              : defaultImg(info.details_img_url)}
          </div>
          <div className={styles.coursepreviewOperate}>
            <div className={styles.button} onClick={() => this.download()}>
              <Icon style={{ fontSize: 20 }} type="download" />
              <span>{info.download_count}人下载</span>
            </div>
            {collectBtn}
            {/* {likeBtn} */}
            <Button
              disabled={!info.related}
              onClick={() => this.toDetail(info.related.id, info.related.type)}
            >
              跳转视频
            </Button>
          </div>
        </div>
        {modalRender()}
        {previewPic(this.state.previewImg)}
      </div>
    )
  }
}

export default CoursePreview
